import React from "react";
import styled from "@emotion/styled";

const MutationCardContainer = styled.div`
  background: ${props => (props.plus ? "#2EAF76" : "#D40F37")};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  border-radius: 5px;
  margin-bottom: 15px;
  width: 100%;

  h4 {
    margin: 0;
    font-family: ${props => props.theme.fonts.subheading};
    text-transform: capitalize;
    font-size: 20px;
  }

  h3 {
    margin: 0;
    font-family: ${props => props.theme.fonts.subheading};
    font-size: 16px;
    font-weight: normal;
  }
`;

const DetailMutation = styled.div`
  display: flex;
  flex-direction: column;
`;

function MutationCard(props) {
  return (
    <MutationCardContainer {...props}>
      <DetailMutation>
        <h4>{props.exhibitor}</h4>
        <h3>{props.time}</h3>
      </DetailMutation>
      <div
        css={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <h4 style={{ marginRight: "8px" }}>{props.plus ? "+" : "-"}</h4>
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="9.5" cy="9.5" r="9.5" fill="white" />
          <path
            d="M9.68823 14.2651H7.38546V5.73882H9.61644C10.7283 5.73882 11.5529 5.96523 12.0904 6.41805C12.7236 6.95187 13.0402 7.69369 13.0402 8.64351C13.0402 9.67801 12.7034 10.4493 12.0297 10.9573C11.5695 11.2997 10.9086 11.4709 10.0472 11.4709H9.68823V14.2651ZM9.68823 9.55468L9.79315 9.5602C10.0729 9.5602 10.2957 9.47552 10.4613 9.30618C10.627 9.13315 10.7098 8.89753 10.7098 8.59933C10.7098 8.30481 10.6289 8.06552 10.4669 7.88144C10.3049 7.69369 10.0987 7.59981 9.84838 7.59981H9.68823V9.55468Z"
            fill="black"
          />
        </svg>
        <h4 style={{ marginLeft: "8px" }}>{props.point.toLocaleString()}</h4>
      </div>
    </MutationCardContainer>
  );
}

export default MutationCard;
